import {AbstractTransform, TransformInteractionState} from "../abstract-transform";
import {SnapPoint} from "../../snap";
import {Feature, Position} from "geojson";
import {GeometryUtil} from "../../geometry";

export class EditorFeatureTransformRotate extends AbstractTransform<TransformInteractionState> {
  public getVertexIcon(): string {
    return 'map-rotate';
  }

  protected _hasCenter(): boolean {
    return true;
  }

  public transform(state: TransformInteractionState, e: mapboxgl.MapMouseEvent, snapPoint: SnapPoint) {
    let rotatedFeature = GeometryUtil.rotate(this.originalFeature.toGeoJSON() as Feature, this._getRotation(state, snapPoint), state.center);

    this.transformedFeature.setCoordinates((rotatedFeature as any).geometry.coordinates)


    this.displayDrawFeature(this.transformedFeature);
  }

  _getRotation(state: TransformInteractionState, snapPoint: SnapPoint) {
    let newPoint = snapPoint.point as Position;
    let rotateLocation = this.originalFeature.getCoordinate(state.dragPath);

    let rotation = GeometryUtil.pointsAngle(rotateLocation, state.center, newPoint, false);

    let A = state.center[0] * rotateLocation[1] + newPoint[0] * state.center[1] + rotateLocation[0] * newPoint[1];
    let B = rotateLocation[0] * state.center[1] + state.center[0] * newPoint[1] + newPoint[0] * rotateLocation[1];

    //counter clock-wise order
    if (A > B) {
      return 0 - rotation;
    }

    //weird calculation error
    if (rotation > 160) {
      return 0 - rotation;
    }

    return rotation;
  }
}
